import { Controller, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

interface IProps {
  name: string;
}

export default function RHFGaField({ name, ...other }: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...other}
          error={!!error}
          helperText={error?.message}
          fullWidth
          onChange={(e) => {
            let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
            // Insere o hífen após o primeiro caractere, se houver pelo menos 2 caracteres
            if (value.length > 1) {
              value = `${value[0]  }-${  value.slice(1)}`;
            }
            field.onChange(value);
          }}
        />
      )}
    />
  );
}